<template>
    <v-card>
        <v-card-title>Schedule Recurring Issues</v-card-title>

        <v-divider />

        <v-card-text class="mt-4">

            <div id="ag-grid-recurring-issues-container">
                <ag-grid-vue style="width: 100%; height: 100%;" class="ag-theme-balham" v-if="showGrid"
                    :gridOptions="gridOptions"
                    :groupHeaders="true"
                    :rowHeight="48">
                </ag-grid-vue>
            </div>

            <v-btn class="mt-5" text @click="createNewRecurringIssue(null)" :disabled="lockSave"><v-icon small class="mr-1">mdi-plus-circle-outline</v-icon> Create New Recurring Issue</v-btn>

        </v-card-text>

        <v-divider />

        <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn text @click="closeClick">Close</v-btn>
        </v-card-actions>


        <v-dialog v-model="showIssueDetails" max-width="80%" width="1600px" persistent>
            <issue-details v-if="showIssueDetails" @close="cancelIssueChanges" @save="applyIssueChanges" :issue="selectedIssueClone" :type="selectedIssueType" :resources="$props.resources"></issue-details>
        </v-dialog>

    </v-card>
</template>

<script>
import IssueDetails from "@/components/Issues/IssueDetails";
import { AgGridVue } from "ag-grid-vue";
export default {
    name: 'ScheduleIssues',
    props: ['resources', 'recurringIssueIssue'],
    components: {
        IssueDetails,
        'ag-grid-vue': AgGridVue,
    },
    data: () => ({
        lockSave: false,
        recurringIssueList: [],
        showGrid: false,
        gridOptions: null,

        showIssueDetails: false,
        selectedIssueClone: null,
        selectedIssueType: null,
    }),

    computed: {
    },

    methods: {
        getRecurringIssuesSchedule: function() {
            let route = `${TELSA.apiHost}issues/schedule/list`;
            return this.$http.get(route).then(response => {
                let result = response.body;
                console.log('result', result);
                this.recurringIssueList = result;
                this.buildAgGrid();
                TELSA.loading(false);
            });
        },

        buildAgGrid: function() {
            this.showGrid = false;
            this.gridOptions = {};
            this.gridOptions.rowData = this.recurringIssueList;
            this.gridOptions.columnDefs = this.createColumnDefs();

            let agGridHeight = ((48 * this.recurringIssueList.length) + 45);
            document.getElementById('ag-grid-recurring-issues-container').setAttribute("style",`height:${agGridHeight}px; width: 100%;`);

            let self = this;
            this.gridOptions.onGridReady = function(params) {
                self.gridOptions.api.hideOverlay();
                self.gridOptions.columnApi.autoSizeColumns();
                self.$store.commit('setIsDirty', false);
            }

            this.gridOptions.getContextMenuItems = function() {
                return [
                    'copy',
                    'copyWithHeaders',
                    'paste',
                    'csvExport',
                    'excelExport'
                ];
            };

            this.gridOptions.defaultColDef = {
                sortable: true,
                filter: true,
                resizable: true
            }
            this.showGrid = true;
        },

        createColumnDefs: function() {
            let columnDefs = [];
            const self = this;
            columnDefs = [
                { 
                    headerName: 'Edit/Delete', 
                    suppressSizeToFit: true,
                    width: 120, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    cellRenderer: function(params) {
                    let eElement = document.createElement('div');
                    eElement.innerHTML = `<span class="mdi mdi-pencil-circle recurring-issue-action" style="cursor: ${self.lockSave ? 'default' : 'pointer'}; color: ${self.lockSave ? '#E0E0E0' : '#c42111'}; font-size: 20pt" />
                        <span class="mdi mdi-delete-circle recurring-issue-action" style="cursor: ${self.lockSave ? 'default' : 'pointer'}; color: ${self.lockSave ? '#E0E0E0' : '#c42111'}; font-size: 20pt" />`

                    const editIssueButton = eElement.querySelectorAll('.recurring-issue-action')[0];
                    const deleteIssueButton = eElement.querySelectorAll('.recurring-issue-action')[1];

                    editIssueButton.addEventListener('click', function() {
                        event.stopPropagation();
                        if(!self.lockSave) {
                            this.editIssue(params.data);
                        }
                    }.bind(this));
                    deleteIssueButton.addEventListener('click', function() {
                        event.stopPropagation();
                        if(!self.lockSave) {
                            this.deleteRecurringIssueClick(params.data);
                        }
                    }.bind(this));
                    return eElement;
                    }.bind(this)
                },
                { 
                    headerName: '#', 
                    field: 'issue_id', 
                    width: 60, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'} 
                },
                { 
                    headerName: 'Title', 
                    field: 'issue_title', 
                    width: 120, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'} 
                },
                { 
                    headerName: 'Office', 
                    width: 150, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    valueGetter: function(params) {
                        if(!params.data) {
                            return;
                        }
                        let offices = [...new Set(params.data.site_office)];
                        if(offices.length) {
                            return (offices.length == 1 ? offices[0] : '[multiple]');
                        }
                        return '';
                    },
                },
                { 
                    headerName: 'Location', 
                    width: 180, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    valueGetter: function(params) {
                        if(!params.data) {
                            return;
                        }
                        let locations = [...new Set(params.data.site_location)];
                        if(locations.length) {
                            return (locations.length == 1 ? locations[0] : '[multiple]');
                        }
                        return '';
                    },
                },
                { 
                    headerName: 'Revised', 
                    field: 'issue_revised_time', 
                    width: 170, filter: 'date', cellStyle: {'padding-top': '8px', 'text-align': 'left'} 
                },


                { 
                    headerName: 'By User', 
                    width: 120, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    valueGetter: function(params) {
                        return params.data.schedule.sche_username;
                    },
                },
                { 
                    headerName: 'Summary', 
                    width: 170, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    valueGetter: function(params) {
                        let values = params.data.schedule.sche_parameter.split(';');
                        let recurType = values[0];
                        if(recurType == 'Daily') {
                            let frequency = values[1];
                            return `Recurs daily${frequency ? ` every ${frequency} days` : ''}`;
                        }
                        else if(recurType == 'Weekly') {
                            let frequency = values[1];
                            let daysBool = values[2];
                            let ans = `Recurs weekly ${frequency > 1 ? ` every ${frequency} weeks` : ''} on`;
                            if(daysBool.split(',')[0] == 'True') {ans += ' Mon';}
                            if(daysBool.split(',')[1] == 'True') {ans += ' Tue';}
                            if(daysBool.split(',')[2] == 'True') {ans += ' Wed';}
                            if(daysBool.split(',')[3] == 'True') {ans += ' Thu';}
                            if(daysBool.split(',')[4] == 'True') {ans += ' Fri';}
                            if(daysBool.split(',')[5] == 'True') {ans += ' Sat';}
                            if(daysBool.split(',')[6] == 'True') {ans += ' Sun';}
                            return ans;
                        }
                        else if(recurType == 'Monthly') {
                            let frequency = values[1];
                            let monthDay = values[2];
                            return `Recurs monthly${frequency > 1 ? ` every ${frequency} months` : ''} on day ${monthDay}`;
                        }
                        else if(recurType == 'Yearly') {
                            let frequency = values[1];
                            return `Recurs anually${frequency > 1 ? ` every ${frequency} years` : ''} on starting date`;
                        }
                    },
                },
                { 
                    headerName: 'Time', 
                    width: 120, filter: 'date', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    valueGetter: function(params) {
                        return params.data.schedule.sche_time;
                    },
                },
                { 
                    headerName: 'Start Date', 
                    width: 110, filter: 'date', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    valueGetter: function(params) {
                        return params.data.schedule.sche_start_time;
                    },
                },
                { 
                    headerName: 'End Date', 
                    width: 110, filter: 'date', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    valueGetter: function(params) {
                        return params.data.schedule.sche_end_time;
                    },
                },
            ];
            return columnDefs;
        },

        createNewRecurringIssue: function(existingIssue) {
            let route = `${TELSA.apiHost}issues/new`;
            this.$http.get(route).then(response => {
                let newIssueId = response.body;
                this.selectedIssueClone = {
                    alarm_full_text: existingIssue ? existingIssue.alarm_full_text : "",
                    alarm_id: existingIssue ? existingIssue.alarm_id : 0,
                    files: [],
                    issue_affected: existingIssue ? existingIssue.issue_affected : 0,
                    issue_affected_type: existingIssue ? existingIssue.issue_affected_type : "Users",
                    issue_autoclose_time: "",
                    issue_category: existingIssue ? existingIssue.issue_category : "[Unassigned]",
                    issue_cause: existingIssue ? existingIssue.issue_cause : "[Unassigned]",
                    issue_close_time: null,
                    issue_close_user: null,
                    issue_description: existingIssue ? existingIssue.issue_description : "",
                    issue_due_time: TELSA.moment.tz(this.$store.state.batchConfig.timezone).add(1, 'days').format('YYYY-MM-DD HH:mm:ss'),
                    issue_duplicate_id: existingIssue ? existingIssue.issue_duplicate_id : 0,
                    issue_fcc_status: existingIssue ? existingIssue.issue_fcc_status : "[not reportable]",
                    issue_history: [],
                    issue_id: newIssueId,
                    issue_ip_members: existingIssue ? existingIssue.issue_ip_members : "",
                    issue_ip_options: existingIssue ? existingIssue.issue_ip_options : "0;0",
                    issue_open_time: null, // This will be set to now() upon save
                    issue_open_user: this.$store.state.user.user_username,
                    issue_options: existingIssue ? existingIssue.issue_options : "0;0",
                    issue_owner: existingIssue ? existingIssue.issue_owner : this.$store.state.user.user_username,
                    issue_priority: existingIssue ? existingIssue.issue_priority : "Normal",
                    issue_remarks: existingIssue ? existingIssue.issue_remarks : [],
                    issue_revised_time: null, // This will be set to now() upon save
                    issue_services: existingIssue ? existingIssue.issue_services : "",
                    issue_severity: existingIssue ? existingIssue.issue_severity : "OBSERVATIONAL",
                    issue_solution: existingIssue ? existingIssue.issue_solution : "",
                    issue_solve_time: TELSA.moment.tz(this.$store.state.batchConfig.timezone).format('YYYY-MM-DD HH:mm:ss'), // This will be nulled out if disabled upon save
                    issue_start_time: TELSA.moment.tz(this.$store.state.batchConfig.timezone).format('YYYY-MM-DD HH:mm:ss'),
                    issue_status: existingIssue ? existingIssue.issue_status : "Open",
                    issue_title: existingIssue ? existingIssue.issue_title : "",
                    issue_update_due: existingIssue ? existingIssue.issue_update_due : 0,
                    site_id: existingIssue ? existingIssue.site_id : [],
                    site_locale: existingIssue ? existingIssue.site_locale : [],
                    site_location: existingIssue ? existingIssue.site_location : [],
                    site_name: existingIssue ? existingIssue.site_name : [],
                    site_office: existingIssue ? existingIssue.site_office : [],
                    user_username: existingIssue ? existingIssue.user_username : [],

                    schedule: {
                        issue_id: newIssueId,
                        sche_start_time: TELSA.moment.tz(this.$store.state.batchConfig.timezone).format('YYYY-MM-DD'),
                        sche_end_time: TELSA.moment.tz(this.$store.state.batchConfig.timezone).format('YYYY-MM-DD'),
                        sche_time: TELSA.moment.tz(this.$store.state.batchConfig.timezone).format('hh:mm:ss A'),
                        sche_parameter: 'Daily;1;;',
                        sche_username: this.$store.state.user.user_username,
                        issue_per_site: false,
                        issue_owner_site_technician: false
                    }
                };
                this.selectedIssueType = 'new_recurring';
                this.showIssueDetails = true;
            });
        },

        editIssue: function(issue) {
            this.selectedIssueClone = JSON.parse(JSON.stringify(issue));
            this.selectedIssueType = 'edit_recurring';
            this.showIssueDetails = true;
            this.$store.commit('setIsDirty', true);
        },

        cancelIssueChanges: function() {
            this.showIssueDetails = false;
            this.selectedIssueClone = null;
            this.selectedIssueType = null;
            this.$store.commit('setIsDirty', false);
            this.$store.dispatch('handleRemoveLocks');
        },

        applyIssueChanges: function() {
            if(this.selectedIssueType == 'new_recurring') {
                this.recurringIssueList.push(this.selectedIssueClone);
            }
            else if(this.selectedIssueType == 'edit_recurring') {
                for(let [index, issue] of this.recurringIssueList.entries()) {
                    if(issue.issue_id == this.selectedIssueClone.issue_id) {
                        this.recurringIssueList[index] = this.selectedIssueClone;
                        this.recurringIssueList.splice(0,0);
                        break;
                    }
                }
            }
            this.gridOptions.api.setRowData(this.recurringIssueList);
            this.showIssueDetails = false;
            this.selectedIssueClone = null;
            this.selectedIssueType = null;
            this.setGridHeight();
            this.$store.commit('setIsDirty', false);
        },

        deleteRecurringIssueClick: function(issue) {
            this.$store.commit('showConfirmModal', {
                title: 'Delete Issue Template',
                message: `This operation will permanently delete this recurring issue. Are you sure you want to do this?`,
                type: 'delete',
                hideCancel: false,
                confirmAction: () => this.deleteRecurringIssue(issue)
            });
            
        },
        deleteRecurringIssue: function(issue) {
            TELSA.loading(true);
            let route = `${TELSA.apiHost}issues/recurring/delete`;
            return this.$http.post(route, {args: {lock: this.$store.state.lock, issue_id: issue.issue_id}}).then(response => {
                let result = response.body;
                this.recurringIssueList.splice(this.recurringIssueList.indexOf(issue), 1);
                this.gridOptions.api.setRowData(this.recurringIssueList);
                TELSA.loading(false);
            });
        },

        closeClick: function() {
            this.$store.dispatch('handleRemoveLocks');
            this.$emit('close');
        },

        setGridHeight: function() {
            let agGridHeight = ((48 * this.recurringIssueList.length) + 45);
            document.getElementById('ag-grid-recurring-issues-container').setAttribute("style",`height:${agGridHeight}px; width: 100%;`);
        }
    },

    watch: {
    },

    mounted() {
        // Permissions Check
        let permission = TELSA.checkPermission(this.$store.state.user, 'admin/issue/schedule-recurring');
        if(!permission) {
            let self = this;
            this.$store.commit('insufficientPermissions', {
                confirmAction: function(){self.getRecurringIssuesSchedule()}
            });
            this.lockSave = true;
            return;
        }

        let lockName = `edit_recur_issues`;
        this.$store.dispatch('getLock', lockName).then(lockOwner => {
            this.getRecurringIssuesSchedule().then(v => {
                if(lockOwner) {
                    // Disable save and let user know page is locked!
                    this.lockSave = true;
                    this.$store.commit('showConfirmModal', {
                        title: 'Lock Warning',
                        message: `The Recurring Issues are already locked for editing by <font color="#FB8C00"><b>${lockOwner}</b></font>. You cannot edit them at this time.`,
                        type: 'warning',
                        hideCancel: true,
                        confirmAction: function(){}
                    });
                }
                TELSA.loading(false);
                if(this.$props.recurringIssueIssue && !this.lockSave) {
                    // They're coming here from wanting to create a new recurrin issue from an already esisting issue.
                    this.createNewRecurringIssue(this.$props.recurringIssueIssue);
                }
            });
        });
    }


};
</script>

<style scoped>

    #ag-grid-recurring-issues-container {
        max-height: 60vh;
    }

    /* #ag-grid-recurring-issues-container .ag-row {
        background-color: #424242;
        color: #ffffff !important;
    } */

</style>


